import React from "react";

import styled from "styled-components";
import OpponentCards from "../opponentCards/opponentCards";
import HandCards from "../handCards/handCards";
import CardStack from "../cardStack/cardStack";
import ControlButtons from "../controlButtons/controlButtons";
import PlayerControls from "../playerControls/playerControls";
import ScoreBoard from "../scoreBoard/scoreBoard";
import { useStore } from 'react-context-hook';
import SocketContext from '../../socket-context'

const BoardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: space-between;
`;

const TopRow = styled.div`
    align-self: center;
`;

const MiddleRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

const BottomRow = styled.div`
    align-self: center;
`;

const Wish = styled.div`
    font-size: 16px;
    font-weight: 700;
`;

const StackWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const GameBoard = () => {
    const [game] = useStore('game', {});
    const [player] = useStore('player', 0);
    const {cardCounts, handCards, cardStack, wish} = game;
    return (
        <BoardWrapper>
            <ScoreBoard />
            <TopRow>
                <OpponentCards count={cardCounts[(player + 2) % 4]} player={(player + 2) % 4}/>
            </TopRow>
            <MiddleRow>
                <OpponentCards count={cardCounts[(player + 3) % 4]} player={(player + 3) % 4}/>
                <StackWrapper>
                    {wish && wish !== 'None' && <Wish>Wish: {wish}</Wish>}
                    <CardStack cards={cardStack}/>
                </StackWrapper>
                <OpponentCards count={cardCounts[(player + 1) % 4]} player={(player + 1) % 4}/>
            </MiddleRow>
            <BottomRow>
                <SocketContext.Consumer>
                    {socket => <PlayerControls player={player} socket={socket} handCards={handCards}/>}
                </SocketContext.Consumer>
                <SocketContext.Consumer>
                    {socket => <HandCards handcards={handCards[player]}  player={player} socket={socket} showButtons/>}
                </SocketContext.Consumer>
            </BottomRow>
            <ControlButtons />
        </BoardWrapper>
    );
};

export default GameBoard;